import { SEARCH_ACTION } from "../actions/actionTypes";
import { SearchData, SearchLocateData } from "../actions/searchAction";
import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../utils/request";
import { Loader } from "../../common/sysco-ui-components/services/commonServices";
import { toast } from "react-toastify";
import { SUPPLIER_PATH } from "../../config/path";

export function* searchSuppWeb(action) {
  let data1 = action.data[0].criteria.filter(
    val => val.attrValue.length !== 0
  );
  let data2 = action.data[1].criteria.filter(
    val => val.attrValue.length !== 0
  );
  action.data[0].criteria = data1;
  action.data[1].criteria = data2;

  const searchQueries = {
    query1: JSON.stringify(action.data[0]),
    query2: JSON.stringify(action.data[1])
  };
  if (action.data[4]) searchQueries.query3 = JSON.stringify(action.data[4]);
  if (action.data[2]) searchQueries.query4 = JSON.stringify(action.data[2]);
  const requestAttrs1 = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(searchQueries)
  };
  const reqURLSuppResult = `${SUPPLIER_PATH}/search-results`;

  try {
    const suppWebResult = yield call(request, reqURLSuppResult, requestAttrs1);

    if (action.data[3] === "search") {
      yield put(
        SearchData(
          (suppWebResult.rows[0] && suppWebResult.rows[0].searchResultsLists != null)
            ? suppWebResult.rows[0].searchResultsLists
            : []
        )
      );
    } else {
      yield put(
        SearchLocateData(
          (suppWebResult.rows[0] && suppWebResult.rows[0].searchResultsLists != null)
            ? suppWebResult.rows[0].searchResultsLists
            : []
        )
      );
    }
  } catch (err1) {
    Loader(false);
    yield put(SearchData([]));
    toast.error("Failed to fetch search results, please retry.", { autoClose: false });
  }
}

export default function* suppWebFunction() {
  yield takeLatest(SEARCH_ACTION, searchSuppWeb);
}
